export const translations = {
  fr: {
    nav: {
      studio: "Studio",
      philosophie: "Philosophie",
      savoirFaire: "Savoir-faire",
      galerie: "Galerie",
      temoignages: "Témoignages",
      contact: "Contact",
      signature: "Signature",
      cta: "Consultation gratuite",
    },
    hero: {
      eyebrow: "Studio de Création · Design Global",
      title1: "Pure. Sophistiqué.",
      title2: "Inédit.",
      subtitle:
        "Pur, raffiné, singulier. Un luxe de sérénité et de perfection, ciselé jusqu'au moindre détail. Rêvez grand — et nous donnons des ailes à vos rêves.",
      ctaPrimary: "Consultation gratuite",
      ctaSecondary: "Notre savoir-faire",
    },
    prelude: {
      line: "Bauen wat bleift.",
      sub: "Construire ce qui dure.",
    },
    transmission: {
      eyebrow: "La Transmission",
      title: "Bâtir pour",
      titleAccent: " transmettre",
      intro:
        "Un savoir qui se bâtit comme on élève une maison de famille — et se transmet comme un héritage.",
    },
    about: {
      eyebrow: "Le Studio",
      title: "L'art de donner des ailes",
      titleAccent: " à vos rêves",
      p1: "MEDERNACH LIONEL DESIGNER est un studio de création spécialisé dans le design intérieur et extérieur, et le design global. De la première étincelle d'idée au produit fini, nous vous accompagnons tout au long de votre projet.",
      p2: "Nos compétences croisées nous confèrent une vision globale du marché. Nous nous immergeons au cœur de votre univers afin d'y déceler les solutions les plus pertinentes.",
      p3: "Toute production est précédée d'une phase d'expérimentation, d'une recherche hybride et d'une exploitation des combinaisons possibles.",
      stat1: "Projets livrés",
      stat2: "Années d'expertise",
      stat3: "Rêves réalisés",
      badge1: "Minimalisme",
      badge2: "travaillé à la perfection",
      quote:
        "Je conçois le design comme on bâtit une maison de famille : pour durer, pour traverser les générations. Ce qui m'anime n'est pas la tendance, mais la fondation — ce socle discret sur lequel tout repose, et que l'on oublie trop souvent. Chaque projet que je porte transmet ce que cette terre m'a légué : le sens du solide, du vrai, du patient — et la beauté qui, partout dans le monde, dit le Luxembourg.",
      quoteAuthor: "Lionel Medernach · Designer",
      maxims: [
        "Construire ce qui dure. Transmettre ce qui compte.",
        "Les fondations avant tout.",
        "Un savoir enraciné, pensé pour être transmis.",
      ],
    },
    philosophy: {
      eyebrow: "Notre Philosophie",
      title: "L'Art de la",
      titleAccent: " Forteresse",
      intro:
        "Depuis le rocher du Bock, où naquit le Luxembourg en 963, ce pays a fait de la pierre, du feu et de la patience un art : l'art de durer. De cet héritage, nous puisons une manière singulière de façonner l'espace — un luxe enraciné, taillé pour traverser le temps et porter la beauté de notre pays dans chaque lieu.",
      motto: "Mir wëlle bleiwe wat mir sinn",
      mottoTranslation: "« Nous voulons rester ce que nous sommes »",
      luxemburgensia: "Luxemburgensia",
      luxemburgensiaDesc: "l'âme d'un pays, portée dans chaque lieu",
      pillars: [
        {
          title: "La Pierre",
          desc: "La permanence du rocher fondateur. Des volumes solides, des lignes qui ne vieillissent pas — un design pensé comme une fondation, jamais comme une mode.",
        },
        {
          title: "La Terre Rouge",
          desc: "La chaleur du Minett, ce minerai de fer sublimé en acier. Nous transformons la matière brute en élégance : patines profondes, laiton, tons de terre.",
        },
        {
          title: "Les Casemates",
          desc: "La profondeur cachée des galeries taillées dans le roc. Un luxe qui se dévoile lentement : lumière indirecte, intimité, superposition des matières.",
        },
      ],
    },
    chronicle: {
      eyebrow: "La Chronique",
      title: "Mille ans de",
      titleAccent: " volonté",
      subtitle:
        "Chaque principe de notre design puise dans un moment de l'histoire du Luxembourg. Parcourez la chronique.",
      milestones: [
        {
          year: "963",
          title: "Le Rocher",
          principle: "La fondation",
          text: "Sigefroi acquiert le rocher du Bock. Une nation naît sur la pierre — et avec elle, l'idée qu'un lieu se bâtit pour durer.",
        },
        {
          year: "XVᵉ–XVIIIᵉ",
          title: "La Forteresse",
          principle: "La résilience",
          text: "Assiégé, détruit, reconstruit sans relâche : le « Gibraltar du Nord » apprend à se relever plus fort à chaque épreuve.",
        },
        {
          year: "1867",
          title: "La Renaissance",
          principle: "La transformation",
          text: "Le Traité de Londres démantèle les remparts. La ville se réinvente en jardins, perspectives et lumière : la contrainte devient beauté.",
        },
        {
          year: "1911",
          title: "La Terre Rouge",
          principle: "La matière sublimée",
          text: "L'apogée du Minett. Le minerai de fer devient acier, la matière brute devient puissance et raffinement industriel.",
        },
        {
          year: "Aujourd'hui",
          title: "L'Héritage",
          principle: "La signature",
          text: "Nous héritons de cette volonté : concevoir des espaces enracinés, sincères et taillés pour traverser le temps.",
        },
        {
          year: "Demain",
          title: "La Transmission",
          principle: "L'avenir",
          text: "Nous prolongeons cette lignée : concevoir aujourd'hui les lieux dont on héritera demain — et signer, avec sérénité, l'avenir de l'habitat luxembourgeois.",
        },
      ],
    },
    method: {
      eyebrow: "Notre Méthode",
      title: "Un processus,",
      titleAccent: " une obsession",
      steps: [
        {
          title: "Écoute",
          desc: "Nous plongeons dans votre univers, vos usages, vos rêves. Rien ne se conçoit sans une compréhension intime de vos aspirations.",
        },
        {
          title: "Recherche",
          desc: "Expérimentation, recherche hybride, exploration des combinaisons. Nous cherchons la solution la plus juste, jamais la plus évidente.",
        },
        {
          title: "Concept",
          desc: "Nous traduisons la vision en un concept cohérent : matières, lumières, proportions, ambiance — chaque détail est orchestré.",
        },
        {
          title: "Réalisation",
          desc: "Du croquis au chantier livré, nous pilotons l'exécution avec exigence, jusqu'au dernier millimètre.",
        },
      ],
    },
    manifesto: {
      eyebrow: "Le Manifeste",
      line1: "Nous ne décorons pas des espaces. Nous les bâtissons — pour durer, pour transmettre, pour dessiner l'avenir de l'habitat au Luxembourg —",
      lineAccent: " et pour révéler qui vous êtes.",
      cta: "Commencer votre projet",
    },
    caseStudy: {
      breadcrumbHome: "Accueil",
      breadcrumbProjects: "Réalisations",
      contextTitle: "Le contexte",
      visionTitle: "La vision",
      approachTitle: "L'approche",
      materialsTitle: "Matières & détails",
      galleryTitle: "En images",
      resultTitle: "Le résultat",
      beforeAfterTitle: "Avant / Après",
      beforeLabel: "Avant",
      afterLabel: "Après",
      ctaTitle: "Un projet en tête ?",
      ctaText:
        "Offrons à votre espace la même attention. Réservez votre consultation gratuite, sans engagement.",
      ctaButton: "Consultation gratuite",
      prev: "Projet précédent",
      next: "Projet suivant",
      viewCase: "Découvrir l'étude de cas",
    },
    services: {
      eyebrow: "Savoir-faire",
      title: "Une expertise,",
      titleAccent: " trois univers",
      cta: "Discutons de votre projet",
      items: [
        {
          title: "Design Intérieur",
          desc: "Des espaces intérieurs sculptés avec précision, où chaque matière, chaque lumière et chaque proportion révèle une élégance sans effort.",
        },
        {
          title: "Design Extérieur",
          desc: "Une architecture extérieure audacieuse et intemporelle, pensée pour dialoguer avec son environnement et sublimer chaque perspective.",
        },
        {
          title: "Design Global",
          desc: "Une vision d'ensemble, du concept à la réalisation. Nous orchestrons l'identité complète de votre projet dans une cohérence absolue.",
        },
      ],
    },
    gallery: {
      eyebrow: "Galerie",
      title: "Nos",
      titleAccent: " réalisations",
      subtitle: "Sélectionnez un projet pour découvrir sa galerie complète.",
      photos: "photos",
      categories: {
        interieur: "Design Intérieur",
        exterieur: "Design Extérieur",
        global: "Design Global",
      },
      projects: {
        villa:
          "Une résidence privée où la lumière naturelle sculpte des volumes épurés et intemporels, de la façade aux circulations intérieures.",
        albert:
          "Une rénovation complète, du gros œuvre à l'aménagement final : transformation d'un espace sous combles en un intérieur chaleureux et contemporain, du croquis initial au résultat livré.",
        deuxpm:
          "Une identité complète, orchestrée du concept à la réalisation dans une cohérence absolue : jeux de lumière indirecte, matières nobles et détails maîtrisés.",
      },
    },
    testimonials: {
      eyebrow: "Ils nous ont confié leurs rêves",
      title: "Paroles de",
      titleAccent: " clients",
      items: [
        {
          quote:
            "Un studio qui transforme une simple intuition en un lieu d'exception. La précision et l'élégance de chaque détail dépassent tout ce que nous avions imaginé.",
          role: "Villa privée, Luxembourg-Ville",
        },
        {
          quote:
            "MEDERNACH LIONEL DESIGNER a su capturer l'âme de notre marque et la traduire dans un espace d'une sophistication rare. Une collaboration inoubliable.",
          role: "Boutique flagship, Kirchberg",
        },
        {
          quote:
            "Ils donnent véritablement des ailes aux rêves. Vision globale, exécution parfaite, un luxe minimaliste absolu.",
          role: "Résidence, Belair Luxembourg",
        },
      ],
    },
    consultation: {
      eyebrow: "Consultation offerte",
      title: "Réservez votre",
      titleAccent: " consultation gratuite",
      subtitle:
        "Parlons de votre projet. En quelques minutes, nous cernons vos aspirations et esquissons les premières pistes pour donner vie à votre vision.",
      benefits: [
        "Échange de 30 minutes, sans engagement",
        "Analyse de votre espace et de vos envies",
        "Premières pistes créatives & estimation",
      ],
      name: "Nom complet",
      email: "Adresse e-mail",
      phone: "Téléphone",
      date: "Créneau souhaité (ex : mardi après-midi)",
      projectTypeLabel: "Type de projet",
      budgetLabel: "Budget estimé",
      messagePlaceholder: "Décrivez votre projet (facultatif)...",
      submit: "Réserver ma consultation",
      submitting: "Envoi en cours...",
      projectTypes: [
        "Design Intérieur",
        "Design Extérieur",
        "Design Global",
        "Rénovation complète",
        "Autre",
      ],
      budgets: [
        "Non défini",
        "< 25 000 €",
        "25 000 – 75 000 €",
        "75 000 – 200 000 €",
        "> 200 000 €",
      ],
      success:
        "Merci. Votre demande de consultation a bien été reçue — nous vous recontactons sous 24-48h.",
      error: "Une erreur est survenue. Veuillez réessayer.",
    },
    newsletter: {
      eyebrow: "Cercle privé",
      title: "Rejoignez notre",
      titleAccent: " univers",
      subtitle:
        "Inspirations, projets confidentiels et rendez-vous exclusifs. Une correspondance rare, réservée à quelques-uns.",
      placeholder: "Votre adresse e-mail",
      submit: "S'inscrire",
      submitting: "Envoi...",
      success: "Bienvenue. Vous rejoignez désormais notre cercle privé.",
      error: "Adresse invalide. Veuillez réessayer.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Donnons vie à",
      titleAccent: " votre vision",
      subtitle:
        "Chaque grand projet commence par une conversation. Partagez-nous votre rêve, nous nous chargeons de lui donner des ailes.",
      infoAtelierLabel: "Atelier",
      infoAtelierValue: "Studio Medernach Lionel, Luxembourg",
      infoPhoneLabel: "Téléphone",
      infoEmailLabel: "E-mail",
      name: "Nom complet",
      email: "Adresse e-mail",
      subject: "Sujet du projet",
      message: "Décrivez votre projet...",
      submit: "Envoyer le message",
      submitting: "Envoi en cours...",
      success: "Votre message a bien été reçu. Nous vous répondrons très prochainement.",
      error: "Une erreur est survenue. Veuillez réessayer.",
    },
    footer: {
      tagline:
        "Studio de création spécialisé dans le design intérieur, extérieur et global. Un luxe minimaliste travaillé à la perfection.",
      navTitle: "Navigation",
      followTitle: "Suivez-nous",
      leStudio: "Le Studio",
      savoirFaire: "Savoir-faire",
      galerie: "Galerie",
      temoignages: "Témoignages",
      contact: "Contact",
      rights: "Tous droits réservés.",
      motto: "Pure · Sophistiqué · Inédit",
      legalLink: "Mentions légales",
      ipNotice:
        "Le logo « tête de lion » et le nom « MEDERNACH LIONEL DESIGNER » sont la propriété exclusive de DREAMUP-design S.à r.l. Toute reproduction ou utilisation non autorisée est interdite et passible de poursuites.",
    },
    legal: {
      title: "Mentions légales & Propriété intellectuelle",
      backHome: "Retour à l'accueil",
      updated: "Dernière mise à jour",
      sections: [
        {
          h: "Éditeur du site",
          p: [
            "Le présent site est édité par DREAMUP-design S.à r.l., société à responsabilité limitée de droit luxembourgeois, immatriculée au Registre de Commerce et des Sociétés de Luxembourg sous le numéro B160763, dont le siège social est établi au 20, rue Notre-Dame, L-2240 Luxembourg.",
            "Contact : lionel@medernach-design.lu · +352 621 830 601",
          ],
        },
        {
          h: "Marque & enseigne",
          p: [
            "« MEDERNACH LIONEL DESIGNER » ainsi que le logo figuratif « tête de lion » sont des signes distinctifs exploités par DREAMUP-design S.à r.l., qui en revendique la propriété pleine et entière.",
          ],
        },
        {
          h: "Propriété intellectuelle",
          p: [
            "L'ensemble des éléments composant ce site et l'identité de la marque — logo « tête de lion », dénomination « MEDERNACH LIONEL DESIGNER », textes, photographies, visuels, mises en page, cartes de visite et supports de communication — constituent des œuvres originales, propriété exclusive de DREAMUP-design S.à r.l., protégées par la loi luxembourgeoise modifiée du 18 avril 2001 sur les droits d'auteur, les droits voisins et les bases de données, ainsi que par la Convention Benelux en matière de propriété intellectuelle (marques et dessins ou modèles) et par le droit de l'Union européenne.",
            "Toute reproduction, représentation, diffusion, modification, adaptation ou exploitation, totale ou partielle, de ces éléments — par quelque procédé et sur quelque support que ce soit — est formellement interdite sans l'autorisation écrite et préalable de DREAMUP-design S.à r.l.",
            "Toute utilisation non autorisée engage la responsabilité civile et pénale de son auteur et pourra faire l'objet de poursuites devant les juridictions compétentes du Grand-Duché de Luxembourg.",
          ],
        },
        {
          h: "Réserve de droits",
          p: [
            "© DREAMUP-design S.à r.l. — Tous droits réservés. Les marques et éléments graphiques présentés sont protégés ; leur usage par un tiers est subordonné à un accord écrit préalable.",
          ],
        },
        {
          h: "Hébergement",
          p: [
            "Le site est hébergé par son prestataire technique ; les informations détaillées relatives à l'hébergeur sont communiquées sur simple demande à l'adresse de contact ci-dessus.",
          ],
        },
      ],
    },
    whatsapp: { prefill: "Bonjour, je souhaite discuter d'un projet de design." },
    signature: {
      eyebrow: "Exclusif · Expérience IA",
      title: "Révélez votre",
      titleAccent: " Signature",
      intro:
        "Répondez à quelques questions et notre intelligence créative révèle, en quelques secondes, l'esquisse de votre espace de rêve et votre profil de style unique.",
      start: "Commencer l'expérience",
      step: "Étape",
      of: "sur",
      back: "Retour",
      questions: [
        {
          key: "ambiance",
          q: "Quelle ambiance vous ressemble ?",
          options: [
            { value: "minimal", label: "Minimalisme épuré" },
            { value: "organic", label: "Chaleur organique" },
            { value: "bold", label: "Audace contrastée" },
            { value: "timeless", label: "Élégance intemporelle" },
          ],
        },
        {
          key: "palette",
          q: "Votre palette de couleurs ?",
          options: [
            { value: "ivory", label: "Ivoire & taupe" },
            { value: "blackgold", label: "Noir & or" },
            { value: "earth", label: "Terres & bois" },
            { value: "greenbrass", label: "Vert profond & laiton" },
          ],
        },
        {
          key: "light",
          q: "Quelle lumière vous inspire ?",
          options: [
            { value: "bright", label: "Lumière naturelle abondante" },
            { value: "soft", label: "Pénombre feutrée & indirecte" },
            { value: "dramatic", label: "Contrastes théâtraux" },
          ],
        },
        {
          key: "space",
          q: "Quel espace souhaitez-vous sublimer ?",
          options: [
            { value: "interior", label: "Intérieur" },
            { value: "exterior", label: "Extérieur" },
            { value: "global", label: "Intérieur & extérieur" },
          ],
        },
        {
          key: "material",
          q: "Vos matières de prédilection ?",
          options: [
            { value: "marblemetal", label: "Marbre & métal" },
            { value: "woodlinen", label: "Bois & lin" },
            { value: "concreteglass", label: "Béton & verre" },
            { value: "velvetbrass", label: "Velours & laiton" },
          ],
        },
      ],
      detailsTitle: "Presque terminé",
      detailsSubtitle:
        "Laissez vos coordonnées pour recevoir votre Signature — et, si vous le souhaitez, votre consultation offerte.",
      namePlaceholder: "Votre prénom (facultatif)",
      emailPlaceholder: "Votre e-mail (facultatif)",
      reveal: "Révéler ma Signature",
      generating: "Création de votre univers...",
      resultEyebrow: "Votre Signature",
      bookCta: "Réserver ma consultation",
      restart: "Recommencer l'expérience",
      error: "La révélation est momentanément indisponible. Réessayez dans un instant.",
    },
  },

  lb: {
    nav: {
      studio: "Studio",
      philosophie: "Philosophie",
      savoirFaire: "Kompetenz",
      galerie: "Galerie",
      temoignages: "Referenzen",
      contact: "Kontakt",
      signature: "Signature",
      cta: "Gratis Berodung",
    },
    hero: {
      eyebrow: "Kreativen Studio · Global Design",
      title1: "Reng. Raffinéiert.",
      title2: "Eenzegaarteg.",
      subtitle:
        "Reng, raffinéiert, eenzegaarteg. E Luxus vu Rou a Perfektioun, ausgeschafft bis op de leschten Detail. Dreemt grouss — a mir ginn ären Dreem Flilleken.",
      ctaPrimary: "Gratis Berodung",
      ctaSecondary: "Eis Kompetenz",
    },
    prelude: {
      line: "Bauen wat bleift.",
      sub: "Weiderginn wat zielt.",
    },
    transmission: {
      eyebrow: "D'Transmissioun",
      title: "Bauen fir",
      titleAccent: " weiderzeginn",
      intro:
        "E Savoir-faire, gebaut wéi een e Familljenhaus opriicht — a weiderginn wéi en Ierwen.",
    },
    about: {
      eyebrow: "D'Studio",
      title: "D'Konscht fir ären Dreem",
      titleAccent: " Flilleken ze ginn",
      p1: "MEDERNACH LIONEL DESIGNER ass e kreativen Studio, spezialiséiert op Interieur- an Exterieur-Design souwéi global Design. Vun der éischter Iddi bis zum fäerdege Resultat begleede mir Iech während ärem ganze Projet.",
      p2: "Eis kombinéiert Kompetenze ginn eis en iwwergräifende Bléck op de Maart. Mir tauchen an ären Universum an, fir do déi passendst Léisungen ze fannen.",
      p3: "Virun all Realisatioun stinn eng Experimentéierungsphase, eng hybrid Fuerschung an d'Notze vun all méiglecher Kombinatioun.",
      stat1: "Realiséiert Projeten",
      stat2: "Joer Erfarung",
      stat3: "Realiséiert Dreem",
      badge1: "Minimalismus",
      badge2: "bis an d'Perfektioun ausgeschafft",
      quote:
        "Ech gestalten den Design, wéi ee e Familljenhaus baut: fir ze bleiwen, fir duerch d'Generatiounen ze goen. Wat mech dreift, ass net d'Moud, mä d'Fundament — dee rouege Sockel op deem alles berout, an deen ee ze dacks vergësst. Mat all Projet ginn ech weider, wat dëst Land mir hannerlooss huet: de Sënn fir dat Solitt, dat Éierlecht an dat Gedëllegt — an d'Schéinheet, déi iwwerall op der Welt Lëtzebuerg seet.",
      quoteAuthor: "Lionel Medernach · Designer",
      maxims: [
        "Bauen wat bleift. Weiderginn wat zielt.",
        "D'Fundamenter virun allem.",
        "E verwuerzelt Wëssen, geduecht fir weiderzeginn.",
      ],
    },
    philosophy: {
      eyebrow: "Eis Philosophie",
      title: "D'Konscht vun der",
      titleAccent: " Festung",
      intro:
        "Zënter dem Bockfiels, wou Lëtzebuerg am Joer 963 gebuer gouf, huet dëst Land aus Steen, Feier a Gedold eng Konscht gemaach: d'Konscht fir ze bleiwen. Aus dësem Ierwen zéie mir eng eenzegaarteg Manéier fir de Raum ze gestalten — e verwuerzelte Luxus, geschnidde fir d'Zäit ze iwwerdauern an d'Schéinheet vun eisem Land an all Raum ze droen.",
      motto: "Mir wëlle bleiwe wat mir sinn",
      mottoTranslation: "— eis national Devise",
      luxemburgensia: "Luxemburgensia",
      luxemburgensiaDesc: "d'Séil vun engem Land, gedroen an all Raum",
      pillars: [
        {
          title: "De Steen",
          desc: "D'Bestännegkeet vum Grënnungsfiels. Solid Volumen, Linnen déi net al ginn — en Design geduecht als Fundament, ni als Moud.",
        },
        {
          title: "D'Rout Äerd",
          desc: "D'Wäermt vum Minett, dëst Eisenäerz zu Stol verwandelt. Mir verwandelen de réie Material an Eleganz: déif Patina, Messing, Äerdtéin.",
        },
        {
          title: "D'Kasematten",
          desc: "Déi verstoppten Déift vun de Galerien, an de Fiels geschnidden. E Luxus deen sech no an no weist: indirekt Luucht, Intimitéit, Iwwerlagerung vun de Materialien.",
        },
      ],
    },
    chronicle: {
      eyebrow: "D'Chronik",
      title: "Dausend Joer",
      titleAccent: " Wëllen",
      subtitle:
        "All Prinzip vun eisem Design zitt aus engem Moment vun der Lëtzebuerger Geschicht. Entdeckt d'Chronik.",
      milestones: [
        {
          year: "963",
          title: "De Fiels",
          principle: "D'Fundament",
          text: "De Sigfrid kritt de Bockfiels. Eng Natioun entsteet um Steen — a mat hir d'Iddi datt eng Plaz gebaut gëtt fir ze bestoen.",
        },
        {
          year: "15.–18. Jh.",
          title: "D'Festung",
          principle: "D'Widerstandsfäegkeet",
          text: "Belagert, zerstéiert, ëmmer erëm nei opgebaut: de « Gibraltar vum Norden » léiert, sech no all Prouf méi staark erëm opzeriichten.",
        },
        {
          year: "1867",
          title: "D'Neigebuert",
          principle: "D'Verwandlung",
          text: "Mam Londoner Vertrag falen d'Festungsmaueren. D'Stad erfënnt sech nei a Gäert, Perspektiven a Luucht: den Zwang gëtt Schéinheet.",
        },
        {
          year: "1911",
          title: "D'Rout Äerd",
          principle: "De verwandelte Material",
          text: "Den Héichpunkt vum Minett. D'Eisenäerz gëtt Stol, de réie Material gëtt Kraaft an industriell Raffinesse.",
        },
        {
          year: "Haut",
          title: "D'Ierfschaft",
          principle: "D'Signature",
          text: "Mir ierwen dëse Wëllen: Raim ze gestalten déi verwuerzelt, éierlech a geschnidde si fir d'Zäit ze iwwerdauern.",
        },
        {
          year: "Muer",
          title: "D'Transmissioun",
          principle: "D'Zukunft",
          text: "Mir verlängeren dës Linn: haut d'Plazen ze gestalten, déi ee muer ierft — a mat Rou d'Zukunft vum Lëtzebuerger Wunnen ze zeechnen.",
        },
      ],
    },
    method: {
      eyebrow: "Eis Method",
      title: "Ee Prozess,",
      titleAccent: " eng Obsessioun",
      steps: [
        {
          title: "Nolauschteren",
          desc: "Mir tauchen an ären Universum, är Gewunnechten an är Dreem an. Näischt entsteet ouni en déift Verständnis vun ären Wënsch.",
        },
        {
          title: "Fuerschung",
          desc: "Experimentéierung, hybrid Fuerschung, Exploratioun vun de Kombinatiounen. Mir sichen déi richtegst Léisung, ni déi offensichtlechst.",
        },
        {
          title: "Konzept",
          desc: "Mir iwwersetzen d'Visioun an e kohärent Konzept: Materialien, Luucht, Proportiounen, Ambiance — all Detail gëtt orchestréiert.",
        },
        {
          title: "Realisatioun",
          desc: "Vun der Skizz bis zum fäerdege Bau steiere mir d'Ausféierung mat gréisster Suergfalt, bis op de leschte Millimeter.",
        },
      ],
    },
    manifesto: {
      eyebrow: "De Manifest",
      line1: "Mir dekoréieren net d'Raim. Mir bauen se — fir ze bleiwen, fir weiderzeginn, fir d'Zukunft vum Wunnen zu Lëtzebuerg ze zeechnen —",
      lineAccent: " a fir ze weisen, wien Dir sidd.",
      cta: "Äre Projet ufänken",
    },
    caseStudy: {
      breadcrumbHome: "Startsäit",
      breadcrumbProjects: "Realisatiounen",
      contextTitle: "De Kontext",
      visionTitle: "D'Visioun",
      approachTitle: "D'Approche",
      materialsTitle: "Materialien & Detailer",
      galleryTitle: "A Biller",
      resultTitle: "D'Resultat",
      beforeAfterTitle: "Virdrun / Duerno",
      beforeLabel: "Virdrun",
      afterLabel: "Duerno",
      ctaTitle: "E Projet am Kapp?",
      ctaText:
        "Loosst eis ärem Raum déiselwecht Opmierksamkeet schenken. Reservéiert är gratis Berodung, ouni Engagement.",
      ctaButton: "Gratis Berodung",
      prev: "Virege Projet",
      next: "Nächste Projet",
      viewCase: "D'Fallstudie entdecken",
    },
    services: {
      eyebrow: "Kompetenz",
      title: "Eng Expertise,",
      titleAccent: " dräi Universen",
      cta: "Schwätze mir iwwer äre Projet",
      items: [
        {
          title: "Interieur-Design",
          desc: "Bannenraim mat Präzisioun geschnidden, wou all Material, all Luucht an all Proportioun eng Eleganz ausstraalt, déi ganz natierlech wierkt.",
        },
        {
          title: "Exterieur-Design",
          desc: "Eng gewaagt an zäitlos baussenzeg Architektur, geduecht fir mat hirem Ëmfeld ze dialogéieren an all Perspektiv ervirzehiewen.",
        },
        {
          title: "Global Design",
          desc: "En iwwergräifende Bléck, vum Konzept bis zur Realisatioun. Mir orchestréieren déi komplett Identitéit vun ärem Projet an enger absoluter Kohärenz.",
        },
      ],
    },
    gallery: {
      eyebrow: "Galerie",
      title: "Eis",
      titleAccent: " Realisatiounen",
      subtitle: "Wielt e Projet fir seng komplett Galerie z'entdecken.",
      photos: "Fotoen",
      categories: {
        interieur: "Interieur-Design",
        exterieur: "Exterieur-Design",
        global: "Global Design",
      },
      projects: {
        villa:
          "Eng privat Residenz, wou d'natierlecht Luucht reng an zäitlos Volumen schneit, vun der Fassad bis an d'Bannenraim.",
        albert:
          "Eng komplett Renovatioun, vum Rohbau bis zur finaler Ariichtung: d'Verwandlung vun engem Dachgeschoss an e waarmt a modernt Interieur, vun der éischter Skizz bis zum fäerdege Resultat.",
        deuxpm:
          "Eng komplett Identitéit, vum Konzept bis zur Realisatioun an enger absoluter Kohärenz orchestréiert: indirekt Luuchtspiller, edel Materialien a beherrschte Detailer.",
      },
    },
    testimonials: {
      eyebrow: "Si hunn eis hir Dreem uvertraut",
      title: "Wierder vun",
      titleAccent: " Clienten",
      items: [
        {
          quote:
            "E Studio dat eng einfach Intuitioun an eng aussergewéinlech Plaz verwandelt. D'Präzisioun an d'Eleganz vun all Detail iwwertreffen alles wat mir eis virgestallt haten.",
          role: "Privat Villa, Lëtzebuerg-Stad",
        },
        {
          quote:
            "MEDERNACH LIONEL DESIGNER huet et fäerdeg bruecht, d'Séil vun eiser Mark ze erfaassen an se an e Raum vun enger rarer Raffinesse ze iwwersetzen. Eng onvergiesslech Zesummenaarbecht.",
          role: "Flagship-Buttek, Kirchberg",
        },
        {
          quote:
            "Si ginn de Dreem wierklech Flilleken. Global Visioun, perfekt Ausféierung, en absolut minimalistesche Luxus.",
          role: "Residenz, Belair Lëtzebuerg",
        },
      ],
    },
    consultation: {
      eyebrow: "Gratis Berodung",
      title: "Reservéiert är",
      titleAccent: " gratis Berodung",
      subtitle:
        "Schwätze mir iwwer äre Projet. A e puer Minutten erfaasse mir är Wënsch a skizzéieren déi éischt Iddien, fir är Visioun Liewen ze ginn.",
      benefits: [
        "Austausch vun 30 Minutten, ouni Engagement",
        "Analyse vun ärem Raum a vun ären Wënsch",
        "Éischt kreativ Iddien & Schätzung",
      ],
      name: "Kompletten Numm",
      email: "E-Mail Adress",
      phone: "Telefon",
      date: "Gewënschte Moment (z.B. Dënschdes nomëttes)",
      projectTypeLabel: "Zort vum Projet",
      budgetLabel: "Geschätzte Budget",
      messagePlaceholder: "Beschreift äre Projet (fakultativ)...",
      submit: "Meng Berodung reservéieren",
      submitting: "Gëtt geschéckt...",
      projectTypes: [
        "Interieur-Design",
        "Exterieur-Design",
        "Global Design",
        "Komplett Renovatioun",
        "Anescht",
      ],
      budgets: [
        "Net definéiert",
        "< 25 000 €",
        "25 000 – 75 000 €",
        "75 000 – 200 000 €",
        "> 200 000 €",
      ],
      success:
        "Merci. Är Berodungsufro ass gutt ukomm — mir mellen eis bannent 24-48 Stonnen.",
      error: "E Feeler ass geschitt. Probéiert w.e.g. nach eng Kéier.",
    },
    newsletter: {
      eyebrow: "Privat Krees",
      title: "Kommt an eisen",
      titleAccent: " Universum",
      subtitle:
        "Inspiratiounen, vertraulech Projeten an exklusiv Rendez-vousen. Eng rar Korrespondenz, e puer Auserwielte virbehalen.",
      placeholder: "Är E-Mail Adress",
      submit: "Aschreiwen",
      submitting: "Gëtt geschéckt...",
      success: "Wëllkomm. Dir gehéiert elo zu eisem privaten Krees.",
      error: "Ongülteg Adress. Probéiert w.e.g. nach eng Kéier.",
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Ginn ärer Visioun",
      titleAccent: " Liewen",
      subtitle:
        "All grousse Projet fänkt mat engem Gespréich un. Deelt eis äre Dram mat, mir ginn him Flilleken.",
      infoAtelierLabel: "Atelier",
      infoAtelierValue: "Studio Medernach Lionel, Lëtzebuerg",
      infoPhoneLabel: "Telefon",
      infoEmailLabel: "E-Mail",
      name: "Kompletten Numm",
      email: "E-Mail Adress",
      subject: "Thema vum Projet",
      message: "Beschreift äre Projet...",
      submit: "Noriicht schécken",
      submitting: "Gëtt geschéckt...",
      success: "Är Noriicht ass gutt ukomm. Mir äntwerten Iech ganz geschwënn.",
      error: "E Feeler ass geschitt. Probéiert w.e.g. nach eng Kéier.",
    },
    footer: {
      tagline:
        "Kreativen Studio spezialiséiert op Interieur-, Exterieur- a global Design. E minimalistesche Luxus, bis an d'Perfektioun ausgeschafft.",
      navTitle: "Navigatioun",
      followTitle: "Follegt eis",
      leStudio: "D'Studio",
      savoirFaire: "Kompetenz",
      galerie: "Galerie",
      temoignages: "Referenzen",
      contact: "Kontakt",
      rights: "All Rechter virbehalen.",
      motto: "Reng · Raffinéiert · Eenzegaarteg",
      legalLink: "Mentions légales",
      ipNotice:
        "De Logo « Léiwekapp » an den Numm « MEDERNACH LIONEL DESIGNER » sinn d'exklusiv Eegentum vun DREAMUP-design S.à r.l. All net-autoriséiert Reproduktioun oder Notzung ass verbueden a ka geriichtlech verfollegt ginn.",
    },
    whatsapp: { prefill: "Moien, ech wéilt iwwer e Design-Projet schwätzen." },
    signature: {
      eyebrow: "Exklusiv · AI-Erliewnis",
      title: "Entdeckt är",
      titleAccent: " Signature",
      intro:
        "Äntwert op e puer Froen, an eis kreativ Intelligenz weist Iech a Sekonnen d'Skizz vun ärem Dramraum an ären eenzegaartege Stilprofil.",
      start: "D'Erliewnis ufänken",
      step: "Schrëtt",
      of: "vun",
      back: "Zréck",
      questions: [
        {
          key: "ambiance",
          q: "Wéi eng Ambiance passt zu Iech?",
          options: [
            { value: "minimal", label: "Reng Minimalismus" },
            { value: "organic", label: "Organesch Wäermt" },
            { value: "bold", label: "Kontrasträich Kéngheet" },
            { value: "timeless", label: "Zäitlos Eleganz" },
          ],
        },
        {
          key: "palette",
          q: "Är Faarwepalette?",
          options: [
            { value: "ivory", label: "Elfebeen & Taupe" },
            { value: "blackgold", label: "Schwaarz & Gold" },
            { value: "earth", label: "Äerdtéin & Holz" },
            { value: "greenbrass", label: "Déif Gréng & Messing" },
          ],
        },
        {
          key: "light",
          q: "Wéi eng Luucht inspiréiert Iech?",
          options: [
            { value: "bright", label: "Vill natierlecht Luucht" },
            { value: "soft", label: "Gedämpft & indirekt Hallefdäischtert" },
            { value: "dramatic", label: "Theatralesch Kontraster" },
          ],
        },
        {
          key: "space",
          q: "Wéi ee Raum wëllt Dir opwäerten?",
          options: [
            { value: "interior", label: "Interieur" },
            { value: "exterior", label: "Exterieur" },
            { value: "global", label: "Interieur & Exterieur" },
          ],
        },
        {
          key: "material",
          q: "Är léifste Materialien?",
          options: [
            { value: "marblemetal", label: "Marmer & Metall" },
            { value: "woodlinen", label: "Holz & Lengen" },
            { value: "concreteglass", label: "Beton & Glas" },
            { value: "velvetbrass", label: "Samt & Messing" },
          ],
        },
      ],
      detailsTitle: "Bal fäerdeg",
      detailsSubtitle:
        "Hannerlooss är Kontaktdaten, fir är Signature ze kréien — a wann Dir wëllt, är gratis Berodung.",
      namePlaceholder: "Äre Virnumm (fakultativ)",
      emailPlaceholder: "Är E-Mail (fakultativ)",
      reveal: "Meng Signature entdecken",
      generating: "Ären Universum gëtt erstallt...",
      resultEyebrow: "Är Signature",
      bookCta: "Meng Berodung reservéieren",
      restart: "D'Erliewnis nei ufänken",
      error: "D'Signature ass am Moment net verfügbar. Probéiert an e puer Sekonnen nach eng Kéier.",
    },
  },

  en: {
    nav: {
      studio: "Studio",
      philosophie: "Philosophy",
      savoirFaire: "Expertise",
      galerie: "Gallery",
      temoignages: "Testimonials",
      contact: "Contact",
      signature: "Signature",
      cta: "Free consultation",
    },
    hero: {
      eyebrow: "Creative Studio · Global Design",
      title1: "Pure. Sophisticated.",
      title2: "Unseen.",
      subtitle:
        "Pure, refined, singular. A luxury of serenity and perfection, chiselled down to the smallest detail. Dream big — and we give your dreams wings.",
      ctaPrimary: "Free consultation",
      ctaSecondary: "Our expertise",
    },
    prelude: {
      line: "Bauen wat bleift.",
      sub: "Build what lasts.",
    },
    transmission: {
      eyebrow: "The Transmission",
      title: "Build to",
      titleAccent: " pass on",
      intro:
        "A craft built the way one raises a family home — and passed on like a legacy.",
    },
    about: {
      eyebrow: "The Studio",
      title: "The art of giving wings",
      titleAccent: " to your dreams",
      p1: "MEDERNACH LIONEL DESIGNER is a creative studio specialising in interior and exterior design, and global design. From the very first spark of an idea to the finished result, we support you throughout your entire project.",
      p2: "Our cross-disciplinary skills give us a global vision of the market. We immerse ourselves at the heart of your world to uncover the most relevant solutions.",
      p3: "Every creation is preceded by a phase of experimentation, hybrid research and the exploration of every possible combination.",
      stat1: "Projects delivered",
      stat2: "Years of expertise",
      stat3: "Dreams realised",
      badge1: "Minimalism",
      badge2: "crafted to perfection",
      quote:
        "I approach design the way one builds a family home: to last, to cross generations. What drives me is not the trend, but the foundation — that quiet base on which everything rests, and which we too often forget. Every project I carry passes on what this land bequeathed to me: the sense of the solid, the true, the patient — and the beauty that, the world over, speaks of Luxembourg.",
      quoteAuthor: "Lionel Medernach · Designer",
      maxims: [
        "Build what lasts. Pass on what matters.",
        "Foundations, above all.",
        "A rooted knowledge, meant to be passed on.",
      ],
    },
    philosophy: {
      eyebrow: "Our Philosophy",
      title: "The Art of the",
      titleAccent: " Fortress",
      intro:
        "From the Bock promontory, where Luxembourg was born in 963, our nation turned stone, fire and patience into an art of endurance. We draw on this heritage a singular way of shaping space: a rooted luxury, carved to outlast time.",
      motto: "Mir wëlle bleiwe wat mir sinn",
      mottoTranslation: "\u201CWe want to remain what we are\u201D",
      luxemburgensia: "Luxemburgensia",
      luxemburgensiaDesc: "the soul of a nation, carried into every space",
      pillars: [
        {
          title: "The Stone",
          desc: "The permanence of the founding rock. Solid volumes, lines that do not age — design conceived as a foundation, never as a fashion.",
        },
        {
          title: "The Red Earth",
          desc: "The warmth of the Minett, its iron ore sublimated into steel. We transform raw matter into elegance: deep patinas, brass, earthen tones.",
        },
        {
          title: "The Casemates",
          desc: "The hidden depth of galleries carved in rock. A luxury that reveals itself slowly: indirect light, intimacy, layered materials.",
        },
      ],
    },
    chronicle: {
      eyebrow: "The Chronicle",
      title: "A thousand years of",
      titleAccent: " will",
      subtitle:
        "Every principle of our design is drawn from a moment in Luxembourg's history. Walk through the chronicle.",
      milestones: [
        {
          year: "963",
          title: "The Rock",
          principle: "The foundation",
          text: "Sigefroi acquires the Bock promontory. A nation is born upon stone — and with it, the belief that a place is built to endure.",
        },
        {
          year: "15th–18th c.",
          title: "The Fortress",
          principle: "Resilience",
          text: "Besieged, razed, rebuilt without respite: the \u201CGibraltar of the North\u201D learns to rise stronger after every trial.",
        },
        {
          year: "1867",
          title: "The Rebirth",
          principle: "Transformation",
          text: "The Treaty of London dismantles the ramparts. The city reinvents itself in gardens, vistas and light: constraint becomes beauty.",
        },
        {
          year: "1911",
          title: "The Red Earth",
          principle: "Matter sublimated",
          text: "The peak of the Minett. Iron ore becomes steel, raw matter becomes power and industrial refinement.",
        },
        {
          year: "Today",
          title: "The Legacy",
          principle: "The signature",
          text: "We inherit this will: to shape spaces that are rooted, sincere and carved to outlast time.",
        },
        {
          year: "Tomorrow",
          title: "The Transmission",
          principle: "The future",
          text: "We extend this lineage: shaping today the places that will be inherited tomorrow — and signing, with serenity, the future of Luxembourgish living.",
        },
      ],
    },
    method: {
      eyebrow: "Our Method",
      title: "One process,",
      titleAccent: " one obsession",
      steps: [
        {
          title: "Listen",
          desc: "We immerse ourselves in your world, your habits, your dreams. Nothing is designed without an intimate understanding of your aspirations.",
        },
        {
          title: "Research",
          desc: "Experimentation, hybrid research, exploration of combinations. We seek the most fitting solution, never the most obvious.",
        },
        {
          title: "Concept",
          desc: "We translate the vision into a coherent concept: materials, light, proportions, atmosphere — every detail orchestrated.",
        },
        {
          title: "Delivery",
          desc: "From sketch to delivered site, we steer execution with rigour, down to the last millimetre.",
        },
      ],
    },
    manifesto: {
      eyebrow: "The Manifesto",
      line1: "We do not decorate spaces. We build them — to endure, to transmit, to shape the future of living in Luxembourg —",
      lineAccent: " and to reveal who you are.",
      cta: "Begin your project",
    },
    caseStudy: {
      breadcrumbHome: "Home",
      breadcrumbProjects: "Projects",
      contextTitle: "The context",
      visionTitle: "The vision",
      approachTitle: "The approach",
      materialsTitle: "Materials & details",
      galleryTitle: "In pictures",
      resultTitle: "The result",
      beforeAfterTitle: "Before / After",
      beforeLabel: "Before",
      afterLabel: "After",
      ctaTitle: "A project in mind?",
      ctaText:
        "Let's give your space the same attention. Book your free, no-commitment consultation.",
      ctaButton: "Free consultation",
      prev: "Previous project",
      next: "Next project",
      viewCase: "Explore the case study",
    },
    services: {
      eyebrow: "Expertise",
      title: "One expertise,",
      titleAccent: " three worlds",
      cta: "Let's discuss your project",
      items: [
        {
          title: "Interior Design",
          desc: "Interior spaces sculpted with precision, where every material, every light and every proportion reveals an effortless elegance.",
        },
        {
          title: "Exterior Design",
          desc: "Bold, timeless exterior architecture, designed to dialogue with its surroundings and elevate every perspective.",
        },
        {
          title: "Global Design",
          desc: "A comprehensive vision, from concept to completion. We orchestrate your project's entire identity with absolute coherence.",
        },
      ],
    },
    gallery: {
      eyebrow: "Gallery",
      title: "Our",
      titleAccent: " projects",
      subtitle: "Select a project to explore its full gallery.",
      photos: "photos",
      categories: {
        interieur: "Interior Design",
        exterieur: "Exterior Design",
        global: "Global Design",
      },
      projects: {
        villa:
          "A private residence where natural light sculpts pure, timeless volumes, from the façade to the interior circulation.",
        albert:
          "A complete renovation, from structural work to final fit-out: the transformation of a loft space into a warm, contemporary interior — from the initial sketch to the delivered result.",
        deuxpm:
          "A complete identity, orchestrated from concept to completion with absolute coherence: plays of indirect light, noble materials and mastered details.",
      },
    },
    testimonials: {
      eyebrow: "They entrusted us with their dreams",
      title: "Client",
      titleAccent: " words",
      items: [
        {
          quote:
            "A studio that transforms a simple intuition into an exceptional place. The precision and elegance of every detail exceeded everything we had imagined.",
          role: "Private villa, Luxembourg City",
        },
        {
          quote:
            "MEDERNACH LIONEL DESIGNER captured the soul of our brand and translated it into a space of rare sophistication. An unforgettable collaboration.",
          role: "Flagship boutique, Kirchberg",
        },
        {
          quote:
            "They truly give wings to dreams. Global vision, flawless execution, absolute minimalist luxury.",
          role: "Residence, Belair Luxembourg",
        },
      ],
    },
    consultation: {
      eyebrow: "Complimentary consultation",
      title: "Book your",
      titleAccent: " free consultation",
      subtitle:
        "Let's talk about your project. In just a few minutes, we grasp your aspirations and sketch the first ideas to bring your vision to life.",
      benefits: [
        "A 30-minute chat, no commitment",
        "Analysis of your space and your desires",
        "First creative directions & estimate",
      ],
      name: "Full name",
      email: "Email address",
      phone: "Phone",
      date: "Preferred time (e.g. Tuesday afternoon)",
      projectTypeLabel: "Project type",
      budgetLabel: "Estimated budget",
      messagePlaceholder: "Describe your project (optional)...",
      submit: "Book my consultation",
      submitting: "Sending...",
      projectTypes: [
        "Interior Design",
        "Exterior Design",
        "Global Design",
        "Full renovation",
        "Other",
      ],
      budgets: [
        "Not defined",
        "< €25,000",
        "€25,000 – €75,000",
        "€75,000 – €200,000",
        "> €200,000",
      ],
      success:
        "Thank you. Your consultation request has been received — we'll get back to you within 24-48h.",
      error: "Something went wrong. Please try again.",
    },
    newsletter: {
      eyebrow: "Private circle",
      title: "Join our",
      titleAccent: " world",
      subtitle:
        "Inspiration, confidential projects and exclusive invitations. A rare correspondence, reserved for a select few.",
      placeholder: "Your email address",
      submit: "Subscribe",
      submitting: "Sending...",
      success: "Welcome. You are now part of our private circle.",
      error: "Invalid address. Please try again.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's bring",
      titleAccent: " your vision to life",
      subtitle:
        "Every great project begins with a conversation. Share your dream with us, and we'll give it wings.",
      infoAtelierLabel: "Studio",
      infoAtelierValue: "Studio Medernach Lionel, Luxembourg",
      infoPhoneLabel: "Phone",
      infoEmailLabel: "Email",
      name: "Full name",
      email: "Email address",
      subject: "Project subject",
      message: "Describe your project...",
      submit: "Send message",
      submitting: "Sending...",
      success: "Your message has been received. We'll reply very soon.",
      error: "Something went wrong. Please try again.",
    },
    footer: {
      tagline:
        "Creative studio specialising in interior, exterior and global design. Minimalist luxury crafted to perfection.",
      navTitle: "Navigation",
      followTitle: "Follow us",
      leStudio: "The Studio",
      savoirFaire: "Expertise",
      galerie: "Gallery",
      temoignages: "Testimonials",
      contact: "Contact",
      rights: "All rights reserved.",
      motto: "Pure · Sophisticated · Unseen",
      legalLink: "Legal notice",
      ipNotice:
        "The \u201Clion head\u201D logo and the \u201CMEDERNACH LIONEL DESIGNER\u201D name are the exclusive property of DREAMUP-design S.à r.l. Any unauthorised reproduction or use is prohibited and liable to prosecution.",
    },
    legal: {
      title: "Legal Notice & Intellectual Property",
      backHome: "Back to home",
      updated: "Last updated",
      sections: [
        {
          h: "Site publisher",
          p: [
            "This website is published by DREAMUP-design S.à r.l., a private limited company under Luxembourg law, registered with the Luxembourg Trade and Companies Register under number B160763, with its registered office at 20, rue Notre-Dame, L-2240 Luxembourg.",
            "Contact: lionel@medernach-design.lu · +352 621 830 601",
          ],
        },
        {
          h: "Brand & name",
          p: [
            "\u201CMEDERNACH LIONEL DESIGNER\u201D and the figurative \u201Clion head\u201D logo are distinctive signs operated by DREAMUP-design S.à r.l., which claims full and exclusive ownership of them.",
          ],
        },
        {
          h: "Intellectual property",
          p: [
            "All elements of this website and of the brand identity — the \u201Clion head\u201D logo, the \u201CMEDERNACH LIONEL DESIGNER\u201D name, texts, photographs, visuals, layouts, business cards and communication materials — are original works, the exclusive property of DREAMUP-design S.à r.l., protected by the Luxembourg law of 18 April 2001 on copyright, related rights and databases, as well as by the Benelux Convention on Intellectual Property (trademarks and designs) and by European Union law.",
            "Any reproduction, representation, distribution, modification, adaptation or exploitation, in whole or in part, of these elements — by any process and on any medium whatsoever — is strictly prohibited without the prior written authorisation of DREAMUP-design S.à r.l.",
            "Any unauthorised use engages the civil and criminal liability of its author and may be prosecuted before the competent courts of the Grand Duchy of Luxembourg.",
          ],
        },
        {
          h: "Reservation of rights",
          p: [
            "© DREAMUP-design S.à r.l. — All rights reserved. The trademarks and graphic elements shown are protected; their use by any third party is subject to prior written consent.",
          ],
        },
        {
          h: "Hosting",
          p: [
            "The site is hosted by its technical provider; detailed hosting information is available on request at the contact address above.",
          ],
        },
      ],
    },
    whatsapp: { prefill: "Hello, I'd like to discuss a design project." },
    signature: {
      eyebrow: "Exclusive · AI Experience",
      title: "Reveal your",
      titleAccent: " Signature",
      intro:
        "Answer a few questions and our creative intelligence reveals, in seconds, a glimpse of your dream space and your unique style profile.",
      start: "Begin the experience",
      step: "Step",
      of: "of",
      back: "Back",
      questions: [
        {
          key: "ambiance",
          q: "Which atmosphere feels like you?",
          options: [
            { value: "minimal", label: "Pure minimalism" },
            { value: "organic", label: "Organic warmth" },
            { value: "bold", label: "Bold contrast" },
            { value: "timeless", label: "Timeless elegance" },
          ],
        },
        {
          key: "palette",
          q: "Your colour palette?",
          options: [
            { value: "ivory", label: "Ivory & taupe" },
            { value: "blackgold", label: "Black & gold" },
            { value: "earth", label: "Earth & wood" },
            { value: "greenbrass", label: "Deep green & brass" },
          ],
        },
        {
          key: "light",
          q: "Which light inspires you?",
          options: [
            { value: "bright", label: "Abundant natural light" },
            { value: "soft", label: "Soft, indirect shadow" },
            { value: "dramatic", label: "Theatrical contrast" },
          ],
        },
        {
          key: "space",
          q: "Which space would you elevate?",
          options: [
            { value: "interior", label: "Interior" },
            { value: "exterior", label: "Exterior" },
            { value: "global", label: "Interior & exterior" },
          ],
        },
        {
          key: "material",
          q: "Your favourite materials?",
          options: [
            { value: "marblemetal", label: "Marble & metal" },
            { value: "woodlinen", label: "Wood & linen" },
            { value: "concreteglass", label: "Concrete & glass" },
            { value: "velvetbrass", label: "Velvet & brass" },
          ],
        },
      ],
      detailsTitle: "Almost there",
      detailsSubtitle:
        "Leave your details to receive your Signature — and, if you wish, your complimentary consultation.",
      namePlaceholder: "Your first name (optional)",
      emailPlaceholder: "Your email (optional)",
      reveal: "Reveal my Signature",
      generating: "Creating your world...",
      resultEyebrow: "Your Signature",
      bookCta: "Book my consultation",
      restart: "Restart the experience",
      error: "The reveal is momentarily unavailable. Please try again shortly.",
    },
  },
};
